import React from "react";
import { useDropzone } from "react-dropzone";
import UploadService from "./FileInputProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";

// const initState = {
//   selectedFiles: undefined,
//   currentFile: undefined,
//   progress: 0,
//   message: '',
//   fileInfos: [],
//   url: '',
// };

// function reducer(state, action) {
//   switch (action.type) {
//     case 'setSelectedFiles':
//       return { ...state, selectedFiles: action.payload };
//     case 'setCurrentFile':
//       return { ...state, currentFile: action.payload };
//     case 'setProgress':
//       return { ...state, progress: action.payload };
//     case 'setMessage':
//       return { ...state, message: action.payload };
//     case 'setUrl':
//       return { ...state, url: action.payload };
//     case 'multiple':
//       return { ...state, ...action.payload };
//     default:
//       throw new Error();
//   }
// }

export function Basic(props) {
  const {  state, dispatch } = props;
  // const [state, dispatch] = useReducer(reducer, initState);
  const upload = (file) => {
    let currentFile = file;
    dispatch({ type: 'multiple', payload: { progress: 0, currentFile } });
    UploadService.upload(currentFile, (event) => {
      dispatch({
        type: 'setProgress',
        payload: Math.round((100 * event.loaded) / event.total - 5),
      });
    })
      .then((response) => {
        dispatch({ type: 'multiple', payload: { progress: 100, url:response.data.url } });
        // setVideoUrl(() => response.data.url);
        // setMessage(response.data.message);
      })
      .catch((e) => {
        dispatch({
          type: 'multiple',
          payload: {
            progress: 0,
            message: 'Could not upload the file!',
            currentFile: undefined,
          },
        });
      });
    dispatch({ type: 'setSelectedFiles', payload: undefined });
  };
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    maxFiles: 1,
    onDropAccepted(files, event) {
      upload(files[0]);
    },
  });
  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));
  return (
    <section className="container">
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} component={'input'} name={'file'} accept={'video/*'} />
        <p>Drag 'n' drop some files here, or click to select files</p>
      </div>
      <aside>
        <ul>{files}</ul>
        <LinearProgressWithLabel value={state.progress} />
      </aside>
      <TextField value={state.url} variant={'filled'} />
    </section>
  );
}

export function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
